import { render, staticRenderFns } from "./questionAnswer.vue?vue&type=template&id=f6dbc1c0&scoped=true&"
import script from "./questionAnswer.vue?vue&type=script&lang=js&"
export * from "./questionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./questionAnswer.vue?vue&type=style&index=0&id=f6dbc1c0&scoped=true&lang=css&"
import style1 from "./questionAnswer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dbc1c0",
  null
  
)

export default component.exports